import { DayTypeType } from './day.interface';
import { Lodge } from './lodge.interface';

export interface Festival {
  id?: number;
  title: string;
  title_public?: string;
  public: boolean;
  valid_from_date: string;
  valid_to_date: string;
  created_at?: string;
  updated_at?: string;
  lodges?: Lodge[];
  invoice_sequence?: InvoiceSequence;
}

export interface InvoiceSequence {
  id?: number;
  festival_id: number;
  prefix: string;
  next_invoice_number: number;
}

export interface FestivalOverviewParams {
  date?: string;
  daytype?: DayTypeType;
}
